import DuplicateIcon from '@atlaskit/icon-lab/core/duplicate';
import * as React from 'react';

export function SvgCopyPlus() {
  return <DuplicateIcon label="" testId="ads-refreshed-icon" />;
}
